// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"a95cb4ef","412":"52171084"}[chunkId] + ".chunk.js";
};